/**
 * Map of colors based on validity.
 */ const validityColorMap = {
    valid: 'positive',
    warning: 'warning',
    invalid: 'negative'
};
/**
 * Map of validity states to severity states.
 */ const validitySeverityMap = {
    valid: 'success',
    warning: 'warning',
    invalid: 'danger'
};

export { validityColorMap, validitySeverityMap };
//# sourceMappingURL=validity.js.map
